import { DateRange } from '@/services/create-pulverization'

export function transformUnderscoreInSpaceAndUppercaseFirstLetter(
  text: string,
) {
  return text
    .replace(/_/gi, ' ')
    .split('-')
    .map((text) => text.charAt(0).toUpperCase() + text.slice(1))
    .join(' + ')
}

export function formatPulverizationDateRange(pulverizationDate: DateRange) {
  const { start_date, end_date } = pulverizationDate
  const formattedStartDate = new Date(start_date).toLocaleDateString('pt-BR', {
    timeZone: 'UTC',
  })

  const formattedEndDate = new Date(end_date).toLocaleDateString('pt-BR', {
    timeZone: 'UTC',
  })
  return `${formattedStartDate} - ${formattedEndDate}`
}
